import EventsList from "../components/EventsList"

const BrusselsPage = () => EventsList('Brussels')


export default BrusselsPage